import React from 'react';
import { motion } from 'framer-motion';

export default function MailerShowcase() {
  return (
    <section className="py-24 bg-brand-cream overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="text-center mb-16">
          <span className="inline-block bg-brand-blue/10 text-brand-blue text-xs font-black uppercase tracking-widest px-4 py-1.5 rounded-full mb-4 border border-brand-blue/20">
            The Actual Mailer
          </span>
          <h2 className="text-4xl md:text-6xl font-black text-brand-brown uppercase tracking-tighter italic leading-none">
            Front & Back
          </h2>
          <p className="text-brand-brown/50 font-bold text-lg mt-4 max-w-xl mx-auto">
            A 9″ × 12″ card that hits 5,000 West Valley homes. Your 2.6″ × 3.75″ ad lives alongside other local trades — no direct competitors.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-center justify-items-center">
          <motion.div
            initial={{ opacity: 0, x: -30, rotate: -2 }}
            whileInView={{ opacity: 1, x: 0, rotate: -1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative group"
          >
            <div className="absolute inset-0 bg-brand-blue/20 rounded-2xl blur-2xl scale-95 opacity-0 group-hover:opacity-100 transition-all duration-500" />
            <img
              src="/side-1-mailbox3.png"
              alt="Mailer front side"
              className="relative rounded-2xl shadow-2xl w-full max-w-md border-4 border-white group-hover:scale-[1.02] transition-transform duration-500"
            />
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-brand-brown text-white text-xs font-black uppercase tracking-widest px-5 py-2 rounded-full whitespace-nowrap shadow-lg">
              Front — Ad Side
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30, rotate: 2 }}
            whileInView={{ opacity: 1, x: 0, rotate: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="relative group"
          >
            <div className="absolute inset-0 bg-brand-blue/20 rounded-2xl blur-2xl scale-95 opacity-0 group-hover:opacity-100 transition-all duration-500" />
            <img
              src="/side-2-mailbox3.png"
              alt="Mailer back side"
              className="relative rounded-2xl shadow-2xl w-full max-w-md border-4 border-white group-hover:scale-[1.02] transition-transform duration-500"
            />
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-brand-blue text-white text-xs font-black uppercase tracking-widest px-5 py-2 rounded-full whitespace-nowrap shadow-lg">
              Back — Mailing Panel
            </div>
          </motion.div>
        </div>

        <div className="mt-20 flex flex-wrap justify-center gap-10 text-center">
          {[
            { value: '9″ × 12″',     label: 'Card Size' },
            { value: '5,000',        label: 'Homes Per Drop' },
            { value: '16pt',         label: 'Card Stock' },
            { value: '16 Slots',     label: 'Ad Positions' },
          ].map((stat, i) => (
            <div key={i} className="flex flex-col items-center gap-1">
              <span className="text-3xl font-black text-brand-blue uppercase tracking-tight">{stat.value}</span>
              <span className="text-xs font-black text-brand-brown/40 uppercase tracking-widest">{stat.label}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
